/* ================================================
   MAUVAIS GARÇON — Unlock / Persistence System
   Tracks safe clicks, stores tokens in localStorage.
   Tokens are checked by the locked product template.
   ================================================ */

const MG_UNLOCK = {
  STORAGE_KEY: 'mg_progress',
  TIER_THRESHOLD: 3,  // safe clicks per tier
  TOTAL_TIERS: 12,
  SECRET: 'mauvaisbadboy2025',

  getProgress() {
    try {
      const raw = localStorage.getItem(this.STORAGE_KEY);
      if (!raw) return this._blank();
      const parsed = JSON.parse(raw);
      return {
        safeClicks:     parsed.safeClicks     || 0,
        unlockedTiers:  parsed.unlockedTiers  || [],
        tokens:         parsed.tokens         || {}
      };
    } catch (_) {
      return this._blank();
    }
  },

  _blank() {
    return { safeClicks: 0, unlockedTiers: [], tokens: {} };
  },

  _save(progress) {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(progress));
    } catch (_) {}
  },

  generateToken(tier) {
    return btoa('mg_tier_' + tier + '_' + this.SECRET);
  },

  hasValidToken(tier) {
    const p = this.getProgress();
    return p.tokens[tier] === this.generateToken(tier);
  },

  isUnlocked(tier) {
    return this.getProgress().unlockedTiers.includes(tier);
  },

  getUnlockedCount() {
    return this.getProgress().unlockedTiers.length;
  },

  getSafeClicks() {
    return this.getProgress().safeClicks;
  },

  // Progress within the current tier (0-5)
  getProgressInTier() {
    return this.getSafeClicks() % this.TIER_THRESHOLD;
  },

  // Call once after each safe click in the game.
  // Returns the newly-unlocked tier index (0-7), or null if no unlock yet.
  recordSafeClick() {
    const progress = this.getProgress();
    progress.safeClicks += 1;

    let newlyUnlocked = null;

    if (progress.safeClicks % this.TIER_THRESHOLD === 0) {
      const tierIndex = Math.floor(progress.safeClicks / this.TIER_THRESHOLD) - 1;
      if (
        tierIndex >= 0 &&
        tierIndex < this.TOTAL_TIERS &&
        !progress.unlockedTiers.includes(tierIndex)
      ) {
        progress.unlockedTiers.push(tierIndex);
        progress.tokens[tierIndex] = this.generateToken(tierIndex);
        newlyUnlocked = tierIndex;
      }
    }

    this._save(progress);
    return newlyUnlocked;
  }
};
